import { render, staticRenderFns } from "./StaffAdvanced.vue?vue&type=template&id=02162f12&scoped=true&"
import script from "./StaffAdvanced.vue?vue&type=script&lang=ts&"
export * from "./StaffAdvanced.vue?vue&type=script&lang=ts&"
import style0 from "./StaffAdvanced.vue?vue&type=style&index=0&id=02162f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02162f12",
  null
  
)

export default component.exports